import { apiFetch } from "./apiClient";

/** Maps to the backend's AccountDto — the real, live Accounts resource. */
export interface AccountDto {
  accountId: number;
  accountCode: string;
  accountName: string;
  contactPerson: string;
  email: string;
  phone: string;
  address: string;
  city: string;
  state: string;
  country: string;
  zipcode: string;
  /** The company logo, printed on its bills. */
  logoUrl?: string | null;
  isActive: boolean;
  planId: number | null;
  /** The one user who may manage this account's admin sections (Tax &
   * Service Settings, Roles, Users, Branches, Status Masters). Set by the
   * Platform Admin; missing from API builds that predate it. */
  primaryAdminUserId?: number | null;
  createdOn: string;
}

/** Shape accepted by both create and update (matches CreateAccountDto/UpdateAccountDto). */
export interface AccountPayload {
  accountCode: string;
  accountName: string;
  contactPerson: string;
  email: string;
  phone: string;
  address: string;
  city: string;
  state: string;
  country: string;
  zipcode: string;
  isActive: boolean;
  planId: number | null;
}

export const listAccounts = async (): Promise<AccountDto[]> => {
  const res = await apiFetch("/accounts");
  return res.json();
};

export const getAccount = async (accountId: number): Promise<AccountDto> => {
  const res = await apiFetch(`/accounts/${accountId}`);
  return res.json();
};

export const createAccount = async (
  payload: AccountPayload
): Promise<AccountDto> => {
  const res = await apiFetch("/accounts", {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return res.json();
};

export const updateAccount = async (
  accountId: number,
  payload: AccountPayload
): Promise<void> => {
  await apiFetch(`/accounts/${accountId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
};

/** Platform Admin only. null clears it. */
export const setAccountPrimaryAdmin = async (
  accountId: number,
  userId: number | null
): Promise<void> => {
  await apiFetch(`/accounts/${accountId}/primary-admin`, {
    method: "PUT",
    body: JSON.stringify({ userId }),
  });
};

export const deleteAccount = async (accountId: number): Promise<void> => {
  await apiFetch(`/accounts/${accountId}`, { method: "DELETE" });
};
